var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('iframe',{staticStyle:{"width":"100%","height":"460px"},attrs:{"id":"catalogo","src":_vm.link,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dd1281d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/download/DetalheCatalogoVirtual.vue
// module id = VRs5
// module chunks = 0